export default function ActionBtnGroupWrapper({children}){
    return (<div className="action-btns space-x-2">{children}</div>);
}